module.exports = __webpack_public_path__ + "images/category_lp/camera/new/store_images/2_c572014dd43216382322a9dcc24dbee2.png";